import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import { RootState } from 'src/configs/store';
import BetHistory from 'src/components/Account/AccountHistory/BetHistory/BetHistory';
import './Ticket.scss';

function Ticket() {
  const secondScreenTicketCode = useSelector((state: RootState) => state.peripherals.secondScreenTicketCode);
  const dispatch = useDispatch();
  const [details, setDetails]= useState(null);
  document.documentElement.classList.add('dark-theme', 'till');

  const getTicketDetails = async () => {
    const newDetails = await dispatch.peripherals.getTicketDetails({ ticket: secondScreenTicketCode });
    if (newDetails && _.size(newDetails) > 0){
      await setDetails(newDetails);
    }
  };

  useEffect(() => {
    if (secondScreenTicketCode) {
      getTicketDetails();
    }
  }, []);

  return (
    <div className="second-screen-ticket dark-theme till">
      <div className="second-screen-ticket__ticket-container">
        {
          details &&
          <div className="second-screen-ticket__container">
            <BetHistory
              key={ details.ticketNumber }
              isTicketDetail
              myBets={ false }
              item={ details }
            />
          </div>
        }
      </div>
    </div>
  );
}

export default Ticket;
